import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'form',
    'card',
    'errors',
    'agreeTerms',
    'submit'
  ]

  static values = { themeName: String, host: Boolean, currency: String, price: String, participants: Number, date: String, hasCustomQuestions: Boolean, hasCustomBranding: Boolean}

  connect() {
    if (this.data.get('public-key')) {
      this.stripe = Stripe(this.data.get('public-key'))
    }

    this.submitTargets.forEach((el) => {
      el.setAttribute("original-text", el.innerText)
    })
    this.determineButtonValidity()
  }

  determineButtonValidity() {
    var enabled = true
    if (this.hasAgreeTermsTarget) {
      enabled = this.agreeTermsTarget.checked
    }

    this.submitTargets.forEach((el) => {
      $(el).attr('disabled', !enabled)
      el.classList.toggle('disabled', !enabled)
    })
  }

  renableButton() {
    $('input[data-disable-with], button[data-disable-with]').each(function () {
      Rails.enableElement(this)
    })
    this.determineButtonValidity()
    this.submitTargets.forEach((el) => {
      el.innerText = el.getAttribute("original-text")
    })
  }

  showPaymentError() {
    $('.payment-modal').addClass('active')
    $('body').addClass('modal-shown')
  }

  initCheckout(event) {
    this.trackPayment()

    var $this = this
    event.preventDefault()

    if (this.hasAgreeTermsTarget && !this.agreeTermsTarget.checked) {
      setTimeout(this.renableButton.bind(this), 500)
      return
    }

    let formData = new FormData(this.formTarget);
    let planFormData = Object.fromEntries(formData.entries());
    $.ajax({
      type: 'POST',
      url: this.data.get('checkout-url'),
      data: planFormData,
      beforeSend: function () { },
      success: function (data) {
        if (data.checkout_session_id.length) {
          $this.stripe.redirectToCheckout({
            sessionId: data.checkout_session_id
          }).then(function (result) {
            alert(result.error.message)
            $this.showPaymentError()
          })
        }
      },
      error: function (err) {
        if (err.status === 412) {
          var obj = $(err.responseText)
          $('.user-inputs').replaceWith(obj.find('.user-inputs'))
          $('.address-inputs').replaceWith(obj.find('.address-inputs'))

          if ($('.user-inputs').find('.is-invalid').length) {
            $this.scrollToElement($('.user-inputs'))
          }
          else if ($('.address-inputs').find('.is-invalid').length) {
            $this.scrollToElement($('.address-inputs'))
          }
        }

        // show error!
        $this.showPaymentError()

        // re-enable buttons
        $this.renableButton()
      }
    })
  }

  requestInvoice(event) {
    this.trackPayment()
  }

  trackPayment() {
    mixpanel.track('Payment Submitted', {
      'themeName': this.themeNameValue,
      'host': this.hostValue,
      'currency': this.currencyValue,
      'price': this.priceValue,
      'participants': this.participantsValue,
      'date': this.dateValue,
      'hasCustomQuestions': this.hasCustomQuestionsValue,
      'hasCustomBranding': this.hasCustomBrandingValue
    }, {send_immediately: true});
  }

  scrollToElement($element) {
    $('html, body').animate({ scrollTop: $element.offset().top - 250 }, 300)
  }
}
